import Project from '../../../components/Project/Project'
import ArtWorkItem from '../../../components/ArtWorkItem/ArtWorkItem'
import Layout from '../../../layout/Layout'
import { yesterday_anotation } from '../../../resources/artWork'

const Home = () => {
  const { images } = yesterday_anotation
  return (
    <Layout>
      <div className='Projects'>
        <Project pr={4} {...yesterday_anotation}>
          {images.map(item => <ArtWorkItem {...item} />)}
        </Project>
      </div>
    </Layout>
  )
}

export default Home;